import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")
  const _component_q_btn = _resolveComponent("q-btn")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_q_select, {
      class: "q-mb-md",
      style: {"max-width":"500px"},
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.model = $event)),
      options: _ctx.options,
      label: "Jurisdicción",
      "option-value": "value",
      "option-label": "text",
      "map-options": "",
      "emit-value": ""
    }, null, 8, ["modelValue", "options"]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.links, (item) => {
      return (_openBlock(), _createBlock("ul", {
        key: item.link
      }, [
        _createVNode("li", null, [
          _createVNode(_component_q_btn, {
            flat: "",
            icon: "download",
            color: "primary",
            label: item.descripcion,
            onClick: ($event: any) => (_ctx.download(item.link))
          }, null, 8, ["label", "onClick"])
        ])
      ]))
    }), 128))
  ], 64))
}